// extracted by mini-css-extract-plugin
module.exports = {"ReallocationDateSelectorWrapper":"appointments__ReallocateShiftFilter__ReallocationDateSelectorWrapper"};